import React from "react";
import "./userdb.scss";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import { useState, useContext, useEffect } from "react";
import { makeRequest } from "../../../axios";
import PeopleOutlineSharpIcon from '@mui/icons-material/PeopleOutlineSharp';

const AnimatedContainer = ({ items }) => {
    const [mappedData, setMappedData] = useState([]);
    const [mappedData1, setMappedData1] = useState(0);
    const [usersData, setUsersData] = useState({});
 
    useEffect(() => {
        makeRequest.get(`user-info/userc/${usersData.info?.ref_code}`).then((res) => {
          setMappedData(res.data)
          setMappedData1(res.data.length)
        } 
        )
    
      }, [usersData]);

      useEffect(() => {
        makeRequest.get("user-info/user").then((res) => {
          setUsersData(res.data)
        } 
        )
    
      }, []);
    
    console.log(mappedData, "iox")
    console.log(usersData)
    
  return (
    <>
    
    <div className="container">
        <div className="cont3" >
          <div className="box1 left-box1">
          
        <div>
        <div style={{display:"flex"}}>
        <h1 style={{fontWeight:"bolder", fontSize:"2.5rem", color:"navy"}}>How Referral </h1> &nbsp;&nbsp;<h1 style={{color:"white"}}>Works.</h1> 
        </div>

     <div style={{margin:"1.5rem 0"}}>
        <p style={{fontWeight:"bolder", fontSize:"1.4rem", marginBottom:"1rem"}}>
     Invite any active investor and earn
     </p>
     <p style={{fontWeight:"bolder", fontSize:"1.4rem"}}>
     instant 5% referral bonus
     </p>
     </div>

    <div style={{margin:"2rem 0"}}>
      <h5>Referral ID</h5>
        <p style={{margin:"1rem 0", fontSize:"1.4rem"}}>{usersData.info?.ref_code}<ContentCopyTwoToneIcon/> </p>
    </div>

        <p style={{marginBottom:".5rem"}}>
            Referral Link
        </p>

        <p style={{fontWeight:"bolder", fontSize:"1rem", marginBottom:"1rem"}}>
        https://equitradezone.com/register?ref={usersData.info?.ref_code}
        <ContentCopyTwoToneIcon/>
        </p>

      </div>
          </div>
          <div className="box1 right-box1">

          
    <div>
      <div style={{display:"flex"}}>
        <h1 style={{fontWeight:"bolder", fontSize:"2.5rem", color:"navy"}}>Your Referral  </h1> &nbsp;&nbsp;<h1 style={{color:"white"}}>Stats.</h1> 
        </div>
        <div style={{margin:"1.5rem 0"}}>
        <p style={{fontWeight:"bolder", fontSize:"1.4rem", marginBottom:"1rem"}}>
     Summary of your Referral
     </p>
     </div>

      <div style={{display:"flex",margin:"1rem",padding:".5rem", justifyContent:"space-between", borderBottom:"1px solid white"}}>
        <p style={{fontWeight:"bolder", fontSize:"1rem"}}>Your Referral(s)</p>
        <p style={{color:"yellow",fontWeight:"bolder", fontSize:"1rem"}}> <PeopleOutlineSharpIcon/> {mappedData1}</p>
      </div>


      <div style={{display:"flex",margin:"1rem",padding:".5rem", justifyContent:"space-between"}}>
        <p style={{fontWeight:"bolder", fontSize:"1rem"}}>Active Referral(s)</p>
        <p style={{color:"green",fontWeight:"bolder", fontSize:"1rem"}}> <PeopleOutlineSharpIcon/>  {mappedData1}</p>
      </div>

      </div>

          </div>



         </div> 


          <div className="box1 bottom-box1">
          <div>
            <p style={{padding:"1rem 0", borderBottom:"1px dotted white"}}>Your Referral(s)</p>
          </div>
          <div>
          { mappedData1 > 0 ? mappedData.map((ref) => (
            <div style={{display:"flex", justifyContent:"space-around", padding:"1.2rem"}}>
               <p>{ref.name}</p>
               <p>{ref.email}</p>
            </div>
          )) : (
            <div
              className=""
              style={{ height: "80px", textAlign: "center" }}
            >
              <h5 style={{ color: "#fff", marginTop: " 40px" }}>
                No Referrals yet
              </h5>
            </div>
          )}
          </div>
          </div>
        </div>
     
    </>
  );
};

export default AnimatedContainer;
